<template>
  <footer class="footer">
    <div class="bg-footer text-footer-color py-3">
      © {{ currentYear }} {{selectedCompanyName}}. All rights reserved.
    </div>
  </footer>
</template>

<script>
import moment from 'moment-timezone'
import { BrandingSettingMixin } from '@/mixins/Booking/BrandingSettingMixin'

export default {
  name: 'PageFooter',
  mixins: [BrandingSettingMixin],
  computed: {
    currentYear () {
      return moment().format('YYYY')
    }
  }
}
</script>
